<template>
  <span class="badge badge-default finished-badge">
    {{ $t('assignments.assignment.completed') }}
  </span>
</template>

<script>
  export default {
    name: 'finished-badge',
  };
</script>



// WEBPACK FOOTER //
// src/components/FinishedBadge.vue